<template>
  <div :class="classList">
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      layer: { type: [Number, String], default: 1, validator: (value: any) => parseInt(value, 10) > 0 },
      elevation: { type: [Number, String], default: 0, validator: (value: any) => parseInt(value, 10) >= 0 },
    },
    computed: {
      classList() {
        return {
          'p-surface': true,
          [`color-surface-${this.layer}`]: true,
          [`elevation-${this.elevation}`]: Number.parseInt(`${this.elevation}`, 10) > 0,
        };
      },
    },
  });
</script>
